var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.montaTexto())+" ")]),(_vm.pegaTimeCount <= 300000)?_c('span',{staticClass:"renovar",on:{"click":function($event){return _vm.renovarLogin()}}},[_c('v-icon',[_vm._v("mdi-refresh")])],1):_vm._e(),_c('span',{staticStyle:{"margin-right":"14px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }